import { AbstractControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

export class AutoCompleteRefModel {
  options: any[];
  inputSearch: BehaviorSubject<string>;
  formControl: AbstractControl;
  fetchCallback: Function;
  totalElements: any;

  constructor(formControl?: AbstractControl, fetchCallback?: Function) {
    this.options = [];
    this.inputSearch = new BehaviorSubject('');
    this.fetchCallback = fetchCallback ? fetchCallback : () => {};
    this.totalElements = null;

    if (formControl) {
      this.formControl = formControl;
    }
  }
}
